import React from "react";
import "../../css/style.css";
import { connect } from "react-redux";
import MerchantPaymentDataUtils from "../../utils/MerchantPaymentDataUtils";
import amex from "../../images/icons/Safekey.svg";
import mc from "../../images/icons/Mastercard.svg";
import visa from "../../images/icons/VisaVerified.svg";
import pci from "../../images/icons/PCI.svg";
import secure from "../../images/icons/secure.svg";

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.objMerchantPaymentDataUtils = new MerchantPaymentDataUtils();
        this.error = null;
        this.loading = null;
        this.merchant_payment_data = null;
        this.CCPopUp = this.CCPopUp.bind(this);
        this.getYear = this.getYear.bind(this);
    }
    CCPopUp = (SEALURL, cId) => {
        window.open("" + SEALURL + "index.php?page=showCert&cId=" + cId + "", "win", 'toolbar=0,location=0,directories=0,status=0,menubar=0,scrollbars=0,resizable=0,width=700,height=585');
        // self.name = "mainWin";
    }

    getYear = () => {
        return (new Date()).getFullYear();
    };

    render() {
        return (
            <> <section class="footer-top container">
                <img src={secure} alt="secure payment" height="24px"/>
                <div class="footer-icons-container">
                    <img class="footer-icons" src={pci} alt="PCI" />
                    <img class="footer-icons" src={visa} alt="verified by visa" />
                    <img class="footer-icons" src={mc} alt="mastercard" />
                    <img class="footer-icons" src={amex} alt="safekey" />
                </div>
            </section>
                <footer class="footer">
                    <div class="container">
                        <div class="row">
                            <div class="copyright col-lg-12 col-md-12 col-sm-12 col-xs-12"> <a href="https://www.pinelabs.com/privacy-policy?TnCDownload=true">Privacy Policy </a> | <a href="https://www.pinelabs.com/terms-of-use?TnCDownload=true"> Terms of Use</a> |<br /> Copyright © {`${this.getYear()-1}-${this.getYear()}`} Pine Labs, All rights reserved. </div>
                        </div>
                    </div>
                </footer>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        merchant_payment_data:
            state.merchantPaymentDataFetchingReducer.merchantPaymentData,
        error: state.merchantPaymentDataFetchingReducer.error,
        loading: state.merchantPaymentDataFetchingReducer.loading,
        paymentAmountUI: state.merchantPaymentDataFetchingReducer.paymentAmountUI
    };
};

export default connect(mapStateToProps)(Footer);
